import Lottie, { LottieProps } from 'react-lottie-player'

export type AnimationProps = LottieProps & {
  animationData: object
}

export const Animation: React.FC<AnimationProps> = ({ animationData, ...props }) => {
  return <Lottie animationData={animationData} {...props} />
}
